import { PresenceClient } from "@formant/core/client/PresenceClient";
import { duration } from "@formant/core/model/duration";
import { IIntervalQuery } from "@formant/core/model/IIntervalQuery";
import { Interval } from "@formant/core/model/Interval";

import { SegmentCache } from "./SegmentCache";
import { StoreCache } from "./StoreCache";

export class PresenceSegmentCache extends SegmentCache<IIntervalQuery, Date> {
    private fetchCache = new StoreCache<IIntervalQuery, Date[]>({
        capacity: 1000,
        staleIntervalMs: 30 * duration.second,
    });

    constructor(
        interval: Interval,
        private presenceClient: PresenceClient,
    ) {
        super(
            interval === "minute"
                ? "hour"
                : interval === "hour"
                  ? "day"
                  : "month",
        );
    }

    protected async fetch(
        token: string,
        query: IIntervalQuery,
    ): Promise<Date[]> {
        return this.fetchCache.getAsync(query, async () =>
            this.presenceClient.query(token, query),
        );
    }

    protected mergeResults(results: Date[][]): Date[] {
        return results.flat();
    }

    protected segmentResult(start: Date, end: Date, results: Date[]): Date[] {
        return results.filter(
            result =>
                result.getTime() >= start.getTime() &&
                result.getTime() < end.getTime(),
        );
    }
}
